'use client';

import {
  useState,
} from 'react';

import { WAG_API_URL, WalkerProfileV6Endpoints } from '../../../constants';

import { V6ReviewsQueryParams, WalkerReviews } from '../../../types/api';
import { tryCatch } from '../../../utils';
import { httpGet } from '../../../wag-react/common/api/api';
import { applyPathParams } from '../../../wag-react/common/api/utils/applyPathParams';

type QueryParams = {
  limit?: number;
  offset?: number;
};

type Props = {
  identifier: string;
  queryParams?: QueryParams | V6ReviewsQueryParams;
  beta?: boolean;
}

export const getWalkerEndorsements = async ({
  identifier,
  queryParams,
}: Props) => {
  const reviewUrl = applyPathParams(WalkerProfileV6Endpoints.GetWalkerReviews)({
    identifier,
  });

  const params = {
    ...queryParams,
    reviewType: 'endorsement',
  } as V6ReviewsQueryParams;

  const [res, err] = await tryCatch(() => httpGet<WalkerReviews>(reviewUrl, {
    baseURL: WAG_API_URL,
    params,
  }));

  if (err) {
    return null;
  }

  return res.data;
};

export const useGetWalkerEndorsements = (identifier: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState<WalkerReviews>({
    items: [],
    page: 1,
    perPage: 10,
    lastPage: 1,
    total: 0,
  });

  const getEndorsements = async (queryParams: V6ReviewsQueryParams) => {
    setIsLoading(true);

    try {
      const reviews = await getWalkerEndorsements({
        identifier,
        queryParams,
      });
      setIsLoading(false);
      setData(reviews as WalkerReviews);

      return reviews as WalkerReviews;
    } catch (_error) {
      setError(_error);
      setIsLoading(false);
      return _error;
    }
  };

  return {
    getEndorsements,
    isLoading,
    error,
    data,
  };
};
